// extracted by mini-css-extract-plugin
export default {"componentWrapper":"OffersDedicated_componentWrapper__Vfv5V","header":"OffersDedicated_header__KJMTT","searchFormWrapper":"OffersDedicated_searchFormWrapper__JEJfC"};